import React from "react";
import { Container } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

import "./Work.css";

// sample images (replace with your own)
import img1 from "../assets/projects/mega-city-hd1.png";
import img2 from "../assets/projects/mega-mension-hd2.png";
import img3 from "../assets/projects/mega-dream-home-hd1.png";
import img4 from "../assets/projects/megha-hieghts.jpg";


const Work = () => {
  return (
    <div className="work-section">
      <Container>
        <div className='heading-center-underline'>
          <h3 className="page-heading text-center">Our Work</h3>
        </div>

<Swiper
  modules={[Autoplay, Pagination]}
  spaceBetween={25}
  slidesPerView={1}   // ✅ IMPORTANT
  loop={true}
  autoplay={{
    delay: 2500,
    disableOnInteraction: false,
  }}
  pagination={{ clickable: false }}
  speed={1500}
  breakpoints={{
    576: { slidesPerView: 1 },
    768: { slidesPerView: 2 },
    992: { slidesPerView: 3 },
  }}
>
          <SwiperSlide>
            <div className="work-card">
              <img src={img1} alt="work1" />
              <div className="work-overlay">
                <h5 className="work-tag-line">Mega City </h5>
              
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="work-card">
              <img src={img2} alt="work2" />
              <div className="work-overlay">
                <h5 className="work-tag-line">Mega Mansions</h5>
                {/* <p>Smart city planning</p> */}
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="work-card">
              <img src={img3} alt="work3" />
              <div className="work-overlay">
                <h5 className="work-tag-line">Mega Dream Homes</h5>
                {/* <p>Luxury residential project</p> */}
              </div>
            </div>
          </SwiperSlide>

               <SwiperSlide>
            <div className="work-card">
              <img src={img4} alt="work3" />
              <div className="work-overlay">
                <h5 className="work-tag-line">Mega Hieghts</h5>
                {/* <p>Luxury residential project</p> */}
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </Container>
    </div>
  );
};

export default Work;